

const API_URL = process.env.VUE_APP_URL
const key = ''

export default {
    LOAD_MEMBER_LIST: `${API_URL}/member/List`, //會員列表
    LOAD_MEMBER_EXCEL: `${API_URL}/member/Excel`, //會員EXCEL
    CHECK_MEMBER_EXCEL: `${API_URL}/member/CheckExcel`, //會員EXCEL
    ADD_MEMBER: `${API_URL}/member/Add`, //增加會員
    LOAD_MEMBER_DETAIL: `${API_URL}/member/Detail`, //會員詳細
    MEMBER_UPDATE: `${API_URL}/member/Update`, //更新會員
    LOAD_USER_LIST: `${API_URL}/user/List`, //員工列表
    ADD_USER: `${API_URL}/user/Add`, //增加員工
    LOAD_USER_DETAIL: `${API_URL}/user/Detail`, //員工詳細
    USER_UPDATE: `${API_URL}/user/Update`, //更新員工
    USER_UPDATE_STATUS: `${API_URL}/user/UpdateStatus`, //更新員工狀態
    LOAD_SHOP_LIST: `${API_URL}/shop/List`, //店櫃列表
    ADD_SHOP: `${API_URL}/shop/Add`, //增加店櫃
    LOAD_SHOP_DETAIL: `${API_URL}/shop/Detail`, //店櫃詳細
    SHOP_UPDATE: `${API_URL}/shop/Update`, //更新店櫃
    SHOP_UPDATE_STATUS: `${API_URL}/shop/UpdateStatus`, //更新店櫃狀態
    LOAD_COUPON_LIST: `${API_URL}/coupon/List`, //禮卷列表
    ADD_COUPON: `${API_URL}/coupon/Add`, //增加禮卷
    COUPON_UPDATE: `${API_URL}/coupon/Update`, //修改禮卷
    COUPON_UPDATE_STATUS: `${API_URL}/coupon/UpdateStatus`, //修改禮卷狀態
    LOAD_COUPON_DETAIL: `${API_URL}/coupon/Detail`, //禮卷詳細
    DELETE_COUPON: `${API_URL}/coupon/Delete`, //刪除禮卷
    LOAD_PRODUCT_LIST: `${API_URL}/product/List`, //商品列表
    ADD_PRODUCT: `${API_URL}/product/Add`, //增加商品
    LOAD_PRODUCT_DETAIL: `${API_URL}/product/Detail`, //商品詳細
    PRODUCT_UPDATE: `${API_URL}/product/Update`, //更新商品
    PRODUCT_UPDATE_STATUS: `${API_URL}/product/UpdateStatus`, //更新商品狀態
    ADD_BUNDLE: `${API_URL}/bundle/Add`, //增加組合商品
    BUNDLE_UPDATE: `${API_URL}/bundle/Update`, //更新組合商品
    BUNDLE_UPDATE_STATUS: `${API_URL}/bundle/UpdateStatus`, //更新組合商品狀態
    LOAD_CLASS_LIST: `${API_URL}/class/List`, //系列別列表
    LOAD_CLASS_DETAIL: `${API_URL}/class/Detail`, //系列別詳細
    ADD_CLASS: `${API_URL}/class/Add`, //增加系列別
    CLASS_UPDATE: `${API_URL}/class/Update`, //更新系列別
    CLASS_UPDATE_STATUS: `${API_URL}/class/UpdateStatus`, //更新系列別狀態
    LOAD_NOTICE_LIST: `${API_URL}/notice/List`, //最新消息列表
    ADD_NOTICE: `${API_URL}/notice/Add`, //增加最新消息
    LOAD_NOTICE_DETAIL: `${API_URL}/notice/Detail`, //最新消息列表
    NOTICE_UPDATE: `${API_URL}/notice/Update`, //更新最新消息
    NOTICE_UPDATE_STATUS: `${API_URL}/notice/UpdateStatus`, //更新最新消息狀態
    DELETE_NOTICE: `${API_URL}/notice/Delete`, //刪除最新消息
    UPDATE_PRODUCT_FILE: `${API_URL}/file/Add/product`, //上傳商品圖片
    UPDATE_BUNDLE_FILE: `${API_URL}/file/Add/bundle`, //上傳組合商品圖片
    UPDATE_ORDER_FILE: `${API_URL}/file/Add/order`, //上傳訂單電子簽名
    UPDATE_NOTICE_FILE: `${API_URL}/file/Add/notice`, //上傳最新消息附檔
    LOAD_ORDER_LIST: `${API_URL}/order/List`, //訂單列表
    LOAD_ORDER_CHANGE_LIST: `${API_URL}/order/ChangeList`, //訂單換貨列表
    LOAD_ORDER_RETURN_LIST: `${API_URL}/order/ReturnList`, //退貨列表
    LOAD_ORDER_EXCEL: `${API_URL}/order/OrderExcel`, //訂單xcel
    LOAD_ORDER_CHANGE_EXCEL: `${API_URL}/order/OrderChangeExcel`, //換貨xcel
    LOAD_ORDER_RETURN_EXCEL: `${API_URL}/order/OrderReturnExcel`, //退貨xcel
    LOAD_ORDER_EXCEL: `${API_URL}/order/OrderExcel`, //訂單xcel
    LOAD_ORDER_CHANGE_DETAIL: `${API_URL}/order/ChangeDetail`, //訂單換貨詳細
    LOAD_ORDER_RETURN_DETAIL: `${API_URL}/order/ReturnDetail`, //訂單退貨詳細
    LOAD_ORDER_DETAIL: `${API_URL}/order/Detail`, //訂單詳細
    LOAD_PERFORMANCE_SHOP_LIST: `${API_URL}/performance/ShopList`, //業績店櫃列表
    LOAD_PERFORMANCE_USER_LIST: `${API_URL}/performance/UserList`, //業績個人列表
    LOAD_PERFORMANCE_USER_EXCEL: `${API_URL}/performance/UserExcel`, //業績個人EXCEL
    CHECK_PERFORMANCE_USER_EXCEL: `${API_URL}/performance/CheckUserExcel`, //業績個人EXCEL
    LOAD_PERFORMANCE_SHOP_EXCEL: `${API_URL}/performance/ShopExcel`, //業績店櫃EXCEL
    CHECK_PERFORMANCE_SHOP_EXCEL: `${API_URL}/performance/CheckShopExcel`, //業績店櫃EXCEL
    UPDATE_MEMBER_POINT: `${API_URL}/memberpoint/Update`, //修改點數規則
    LOAD_MEMBER_POINT_DETAIL: `${API_URL}/memberpoint/Detail`, //點數規則詳細
    ADD_POINT_GIFT: `${API_URL}/pointgift/Add`, //新增點數兌換物品
    UPDATE_POINT_GIFT: `${API_URL}/pointgift/Update`, //修改點數兌換物品
    LOAD_POINT_GIFT_LIST: `${API_URL}/pointgift/List`, //點數兌換物品列表
    DELETE_POINT_GIFT: `${API_URL}/pointgift/Delete`, //刪除點數兌換物品
    ADD_PERMISSION: `${API_URL}/permission/Add`, //增加權限
    LOAD_PERMISSION_LIST: `${API_URL}/permission/List`, //權限列表
    UPDATE_PERMISSION: `${API_URL}/permission/Update`, //修改權限
    DELETE_PERMISSION: `${API_URL}/permission/Delete`, //刪除權限
    LOAD_FILE: `${API_URL}/file/Link/`, //讀取檔案
    LOAD_CITY: `${API_URL}/postcode/QueryCity/`, //查詢城市
    LOAD_AREA: `${API_URL}/postcode/QueryAreaByCity`, //查詢區域
    LOAD_CODE: `${API_URL}/postcode/QueryCode`, //查詢郵遞區號
    BASE_LOGIN: `${API_URL}/login/LoginWeb/?conf=811dd6004297603d`,
    LOAD_VIP_LIST: `${API_URL}/vip/List` // 會員vip列表

};

